<template>
  <transition name="c-base-modal">
    <div v-if="show" class="c-base-modal">
      <div class="c-base-modal__center">
        <div class="c-base-modal__body">
          <button
            v-if="btnClose"
            @click="close"
            type="button"
            class="c-base-modal__button-close"
          >
            <!-- Slot to set icon button close -->
            <slot name="btn-close-icon"></slot>
          </button>
          <!-- Slot to set content body -->
          <slot></slot>
        </div>
        <div v-if="isFooter" class="c-base-modal__footer">
          <!-- Slot to set content footer -->
          <slot name="footer"></slot>
        </div>
      </div>
      <a
        @click="withClickOverlay ? close : ''"
        class="c-base-modal__overlay"
      ></a>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    // Optional function callback that triggers when modal is closed.
    onClose: {
      type: Function,
      required: false,
    },

    withClickOverlay: {
      type: Boolean,
      default: true,
    },

    btnClose: {
      type: Boolean,
      default: true,
    },

    isFooter: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // Defines whether modal is opened or not
      show: false,
    }
  },

  methods: {
    // Opens the modal.
    open() {
      this.show = true
    },
    // Closes the modal and triggers funcion callback if there's one
    close(emitter) {
      this.show = false
      if (this.onClose && emitter != 'off') this.onClose()
    },
  },
}
</script>

<style lang="scss">
.c-base-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  &__center {
    border-radius: 6px;
    color: $neutral;
    z-index: 55;
    background-color: $white;
    max-width: 600px;
  }

  &__body {
    padding: 20px 16px;
    position: relative;
    height: 100%;

    @media (min-width: $mobile) {
      padding: 20px 32px;
    }
  }

  &__button-close {
    @include position(absolute, 5px, 5px, auto, auto);
    background: none;
    color: #fff;
    border: 0;
    font-size: 28px;
    font-weight: bold;
    outline: none;
    padding: 10px;
    cursor: pointer;
    &:hover,
    > img,
    > svg,
    > span,
    > i {
      color: #fff;
      margin: 0 auto;
    }
  }

  &__title {
    font-size: 24px;
    font-weight: bold;
    margin: 0 0 12px;

    @media (min-width: 480px) {
      font-size: 32px;
      margin-bottom: 18px;
    }
  }

  &__intro {
    font-size: 16px;
    line-height: 1.2;
    margin-bottom: 32px;

    @media (min-width: 480px) {
      font-size: 18px;
      margin-bottom: 48px;
    }
  }

  &__overlay {
    display: block;
    @include position(fixed, 0, 0, 0, 0);
    width: 100%;
    height: 100%;
    z-index: 50;
  }

  // animation
  &-enter-active,
  &-leave-active,
  .c-base-modal__overlay,
  .c-base-modal__center {
    transition: opacity 400ms ease-in-out, transform 400ms ease-in-out;
  }
  &-enter,
  &-leave-to {
    .c-base-modal__overlay {
      opacity: 0;
    }
    .c-base-modal__center {
      transform: translateY(-105%);
    }
  }
}
</style>
